import React, {useEffect}   from 'react';
import ReactGA from "react-ga4";

import Error404             from './paginas/Error404';
import Navbar               from './components/Navbar';
import Cards                from "./components/Cards";
import Informacion        from './components/Informacion';
import Mapa                 from './components/Mapa';
import FormularioContacto   from './components/FormularioContacto';
import Footer               from './components/Footer';

import './styles.css';
import './components/NavBar.css';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "animate.css/animate.min.css";
import {FormattedMessage, FormattedDate} from 'react-intl';

ReactGA.initialize("G-TEYR1163XD");
 
const App = () => {
	return (
		<div className="body">
		    <Navbar />
			<Cards/>
			<Informacion/> 
  		 	
	               	<div className="container">
                       	<div className="container">
            	            <div className="row"> 
					 			<div className="col-md-6">
								  <Mapa/>		
								</div>
						        <div className="col-md-6"> 	 
								  <FormularioContacto/>		 
								</div>		
                            </div>
				        </div>	    
		            </div>				
	            
            
            <Footer/>
			
		</div>
	);
} 
export default App;